import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import usePagination from "../../hooks/usePagination";
import MainPost from "./MainPost";
import LinearProgress from "@mui/material/LinearProgress";
import { Box, Pagination, Divider, Typography } from "@mui/material";
import { useStyles } from "./Articles.styles";

const Articles = ({ posts }) => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const postsPerPage = 4;
  const count = Math.ceil(posts.slice(4).length / postsPerPage);
  const _POSTS = usePagination(posts.slice(4), postsPerPage);

  const boxRef = useRef(null);
  const handleChange = (e, p) => {
    setPage(p);
    _POSTS.customPage(p);
    boxRef.current.scrollIntoView();
  };

  if (!posts.length) {
    return (
      <Box className={classes.root} ref={boxRef}>
        <div className="error-msg">
          <Typography variant="h3" sx={{ color: "#999" }}>
            Please wait a little bit for developer's sake
          </Typography>
          <Typography variant="body" sx={{ color: "#888" }}>
            Because of free plans of web hostings response from server is slow.
          </Typography>
          <div></div>
          <LinearProgress
            color="inherit"
            sx={{ margin: "3rem auto", width: "50%" }}
          />
        </div>
      </Box>
    );
  }
  return (
    <Box className={classes.root} ref={boxRef}>
      <Box
        position="static"
        sx={{ xs: { width: "100%" }, md: { width: "50%" } }}
      >
        {_POSTS.currentData().length > 0 &&
          _POSTS.currentData().map((post) => (
            <React.Fragment key={post._id}>
              <Box className={classes.content}>
                <img src={post?.image} alt={`${post?.title}`} loading="lazy" />
                <Box mr={3} textAlign={"right"}>
                  <Typography sx={{ fontSize: "0.8rem" }}>
                    <Link to={`/${post._id}`}>{post?.title}</Link>
                  </Typography>
                  <Typography variant="caption">
                    {new Date(post?.updatedAt).toLocaleDateString()}
                  </Typography>
                </Box>
              </Box>
              <Divider variant="middle"></Divider>
            </React.Fragment>
          ))}
        {/* Pagination */}
        {posts.length > postsPerPage && (
          <Box className={classes.content}>
            <Pagination count={count} page={page} onChange={handleChange} />
          </Box>
        )}
      </Box>
      {/* post on big boarder */}
      <MainPost mainPost={posts[3]} />
    </Box>
  );
};

export default Articles;
